import PropTypes from 'prop-types';
import MomentPropTypes from 'react-moment-proptypes';
import { stopBehaviourTagsPropTypes } from './stopBehaviour.type';

export const OrderStopType = {
  LOADING_UNLOADING: 'LOADING_UNLOADING',
  LOADING: 'LOADING',
  UNLOADING: 'UNLOADING',
  UNKNOWN: 'UNKNOWN',
};

export const RequestStopType = {
  LOADING: 'LOADING',
  UNLOADING: 'UNLOADING',
};

export const stopTimeSlotPropTypes = PropTypes.shape({
  id: PropTypes.string,
  startMoment: MomentPropTypes.momentObj,
  endMoment: MomentPropTypes.momentObj,
});

export const stopPlacePropTypes = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  companyOwnerId: PropTypes.string,
  personOwnerId: PropTypes.string,
  street: PropTypes.string,
  houseNumber: PropTypes.string,
  localNumber: PropTypes.string,
  city: PropTypes.string,
  postcode: PropTypes.string,
  country: PropTypes.string,
});

export const stopPropTypes = PropTypes.shape({
  id: PropTypes.string,
  sequence: PropTypes.number,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  isLoad: PropTypes.bool,
  isUnload: PropTypes.bool,
  // Absent for an untagged stop; absence means OPERATIONAL.
  behaviourTags: stopBehaviourTagsPropTypes,
  timeSlot: stopTimeSlotPropTypes,
  place: stopPlacePropTypes,
});

export const stopsPropTypes = PropTypes.arrayOf(stopPropTypes);
